import {
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';

/**
 * The method is required to search for all invalid fields in the form
 * @param {FormGroup | FormArray} formGroup
 * @returns {Promise<string[]>}
 */
const validateAllFormFields = (
  formGroup: UntypedFormGroup | UntypedFormArray
): Promise<string[]> => {
  // Temporary variable for aggregating invalid fields
  // This information is required for sending to the analyst
  const invalidFields = [];
  // A recursive method of finding invalid fields
  const validate = (formGroup: UntypedFormGroup | UntypedFormArray) => {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      if (control instanceof UntypedFormControl) {
        control.markAsTouched({ onlySelf: true });
        if (!formGroup.get(field).valid) {
          invalidFields.push(field);
        }
      } else if (
        control instanceof UntypedFormGroup ||
        control instanceof UntypedFormArray
      ) {
        validate(control);
      }
    });
  };

  return new Promise((res) => {
    validate(formGroup);
    return res(invalidFields);
  });
};

export default validateAllFormFields;
